import React, { Component } from 'react'
import 'react-multi-carousel/lib/styles.css'
import '../assets/golf-course-detail.css'
import { withNamespaces } from 'react-i18next'
import httpRequest from '../components/request-api'

class PreTournament extends Component {
  constructor(props) {
    super(props);
    this.state = {
        tournamentName : [],
        preload: false,
        photoIcon: ["/assets/img/tournament-image/1.png", "/assets/img/tournament-image/2.png", "/assets/img/tournament-image/3.png", "/assets/img/tournament-image/4.png"]
    }
  }

    componentDidMount() {
        this.getTournamentCategory()
    }

    getTournamentCategory = async () => {
        this.setState({
            preload: true
        })
        await httpRequest.tournamentCategory().then(result => {
            this.setState({
                tournamentName: result.data.result,
                preload: false
            })
        }).catch(error => {
            this.setState({
                preload: false
            })
            console.log(error);
        })
    }

  render() {
    const { t } = this.props;
    const { tournamentName, photoIcon, preload } = this.state
    const handleClick = (id) => {
        this.props.history.push(`/tournament/${id}/${localStorage.getItem("i18nextLng")}`)
      };
    return (
        <div>
        <section className="categories-area categories-area2" style={{"marginBottom": "7rem"}}>
        <div className="container" >
        <h3 className="text-left color-text-header mb-4 mt-4">{t('tournamentCategory')}</h3>
        { tournamentName.length === 0 && !preload ? <h6 className="p-5">Tournament type not found. Please try again !</h6>:
            <>
                { preload ?  
                  <div id="preloader-active">
                    <div className="preloader d-flex align-items-center justify-content-center" style={{backgroundColor: "initial"}}>
                      <div className="preloader-inner position-relative">
                        <div className="preloader-circle"></div>
                        <div className="preloader-img pere-text">
                          <img src="/assets/img/logo/TGALogo.png" alt=""/>
                        </div>
                      </div>
                    </div>
                  </div> :
            <div className="row">
                { tournamentName.map((item, index)=> (
            <div className="col-lg-6 col-md-6 col-sm-6 cursor" onClick={() => handleClick(item.technical_name)} key={index}>
                <div className="text-center mb-50 padding-tournament-card">{/* single-cat */}
                  <div className="cat-cap text-left">
                  <h6 className="blue-color text-center">   <img src={photoIcon[index]} className="mr-2" alt=""/> {t(item.name_en)} ({item.tournament_count})</h6>
                  </div>
                </div>
            </div>
                ))
                }
            </div>
              }
            </>
        }
        </div>
        </section>
    </div>

    );
  }
}

export default withNamespaces()(PreTournament);